/**
https://developer.mozilla.org/en-US/docs/Web/Events/resize

Since resize events can fire at a high rate, the event handler
shouldn't execute computationally expensive operations such as
DOM modifications. Instead, it is recommended to throttle the
event using requestAnimationFrame, setTimeout or customEvent
*/
module.exports = (function () {
	var callbacks = [],
		running = false;

	// run the actual callbacks
	function runCallbacks() {
		callbacks.forEach(function (callback) {
			callback();
		});

		running = false;
	}

	// fired on resize event
	function resize() {
		if (!running) {
			running = true;

			if (window.requestAnimationFrame) {
				window.requestAnimationFrame(runCallbacks);
			} else {
				setTimeout(runCallbacks, 66);
			}
		}
	}

	// adds callback to loop
	function addCallback(callback) {
		if (callback) {
			callbacks.push(callback);
		}
	}

	return {
		// public method to add additional callback
		add(callback) {
			let idx = callbacks.indexOf(callback);
			if (!callbacks.length) {
				window.addEventListener('resize', resize);
			}
			if (idx === -1) {
				addCallback(callback);
			}
		},
		remove(callback) {
			let idx = callbacks.indexOf(callback);
			if (idx !== -1) {
				callbacks.splice(idx, 1);
				if (callbacks.length === 0) {
					window.removeEventListener('resize', resize);
				}
			}
		}
	};
})();
